<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Create terminal</h6>
        <h6 v-else class="heading-small text-muted mb-4">Update terminal</h6>

        <!-- <base-alert v-if="errors != null" type="danger">
            <b>You have the following error(s):</b>
            <ul>
                <li v-for="error in errors" v-bind:key="error">
                    {{ error }}
                </li>
            </ul>
        </base-alert> -->

        <form>
            <h6 class="heading-small text-muted mb-4">Basic Information</h6>

                                <div class="row">
                                    <div class="col-lg-12">
                                        <base-input alternative=""
                                                    label="Terminal Code"
                                                    placeholder="Code"
                                                    input-classes="form-control"
                                                    v-model="inputCode"
                                                   
                                        />
                                    </div>

                                     <div class="col-lg-12">
                                        <base-input alternative=""
                                                    label="Name"
                                                    placeholder="Name"
                                                    input-classes="form-control"
                                                    v-model="inputName"
                                                   
                                        />
                                    </div>

                                    <div class="col-lg-12">
                                        <base-input alternative=""
                                                    label="Reference Code"
                                                    placeholder="NaReference Codeme"
                                                    input-classes="form-control"
                                                    v-model="inputReferenceCode"
                                                   
                                        />
                                    </div>
                                </div>

                                <hr class="my-4" />
                                <h6 class="heading-small text-muted mb-4">Site & Template</h6>

                                <base-input label="Site">
                                    <div class="form-group row">
                                        <div class="col-sm-6">
                                            <input type="text" class="form-control" v-model="siteName" disabled>
                                        </div>
                                        <div class="col-sm-6">
                                            <autocomplete
                                              ref="autocomplete"
                                              placeholder="Search Sites"
                                              :source="sitesEndpoint"
                                              input-class="form-control"
                                              results-property="data"
                                              :results-display="formattedDisplay"
                                              :request-headers="authHeaders"
                                              @selected="getSite">
                                            </autocomplete>
                                        </div>
                                    </div>
                                </base-input>

                                <base-input label="Terminal Template">
                                    <div class="form-group row">
                                        <div class="col-sm-6">
                                            <input type="text" class="form-control" v-model="templateName" disabled>
                                        </div>
                                        <div class="col-sm-6">
                                            <autocomplete
                                              ref="autocomplete"
                                              placeholder="Search Terminal Templates"
                                              :source="terminalTemplatesEndpoint"
                                              input-class="form-control"
                                              results-property="data"
                                              :results-display="formattedDisplay2"
                                              :request-headers="authHeaders"
                                              @selected="getTerminalTemplate">
                                            </autocomplete>
                                        </div>
                                    </div>
                                </base-input>

                            
                                <hr class="my-4" />
                                <h6 class="heading-small text-muted mb-4">Other Identifiers</h6>
                                

                                <div class="row">
                                    <div class="col-lg-6">
                                        <base-input alternative=""
                                                    label="Serial No"
                                                    placeholder="00000"
                                                    input-classes="form-control"
                                                    v-model="inputSerialNo"
                                                   
                                        />
                                    </div>

                                    <div class="col-lg-6">
                                        <base-input alternative=""
                                                    label="Machine No"
                                                    placeholder="00000"
                                                    input-classes="form-control"
                                                    v-model="inputMachineNo"
                                                   
                                        />
                                    </div>

                                    <div class="col-lg-6">
                                        <base-input alternative=""
                                                    label="Permit No"
                                                    placeholder="00000"
                                                    input-classes="form-control"
                                                    v-model="inputPermitNo"
                                                   
                                        />
                                    </div>

                                    <div class="col-lg-6">
                                        <base-input alternative=""
                                                    label="Remark"
                                                    placeholder="Remark"
                                                    input-classes="form-control"
                                                    v-model="inputRemark"
                                                   
                                        />
                                    </div>

                                </div>
                                
                                <!-- <div class="float-right">
                                    <br>
                                    <button v-if="($route.params.id > 0)" type="button" class="btn btn-sm btn-default" @click.prevent="viewLicense">View License Key</button> 
                                    &nbsp;&nbsp;<button v-if="($route.params.id == 0)" type="button" class="btn btn-sm btn-primary" @click.prevent="create">Create</button> 
                                    <button v-else type="button" class="btn btn-sm btn-primary" @click.prevent="update">Update</button> 
                                    &nbsp;&nbsp;<button type="button" class="btn btn-sm btn-secondary" @click.prevent="$router.go(-1)">Back</button> 
                                </div> -->

                                <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Add</button>
                                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Edit</button>
                                 </div> 


                            </form>
    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import { mapState } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'
import secureStorage from '../../controllers/secureStorage';

var component_x;

export default {
    components: {
        Autocomplete
    },
    computed: {
        ...mapState(['endPoint', 'profileId']),
    },
    mounted: async function() {
        component_x = this
        if( this.profileId > 0){
            var brand_data = await HTTPRequest.getRequest(component_x.endPoint + 'terminals/' + this.profileId, null)    
            if(brand_data == undefined){
                component_x.$router.go()
            } else {
                if(brand_data["error"] == undefined){
                    component_x.inputName = brand_data["name"]
                    component_x.inputCode = brand_data["code"]
                    component_x.inputReferenceCode = brand_data["reference_code"]
                    component_x.siteName = brand_data["site_name"]
                    component_x.templateName = brand_data["template_name"]
                    component_x.inputSite = brand_data["site_id"]
                    component_x.inputTemplate = brand_data["terminal_template_id"]
                    component_x.inputSerialNo = brand_data["serial_no"]
                    component_x.inputMachineNo = brand_data["machine_no"]
                    component_x.inputPermitNo = brand_data["permit_no"]
                    component_x.inputRemark = brand_data["remark"]
                } else {
                    alert(brand_data["error"])
                    component_x.$router.push("/")
                } 
            }
        }
    },
    data: function(){
        return {
            inputName: '',
            inputCode: '',
            inputReferenceCode: '',
            inputRemark: '',
            inputSerialNo: '',
            inputMachineNo: '',
            inputPermitNo: '',
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
            siteName: '',
            templateName: ''
        }
    },
    methods: {
        viewLicense(){
            var password = prompt('Please input passcode',' ');
            if(password == "123456"){
                var terminal_code = component_x.inputCode
                this.$router.push('../licenses_form/' + terminal_code )
            } else {
                alert("Invalid passcode")
            }
        },
        sitesEndpoint (input) {
            return this.endPoint + '/sites?name=' + input
        },
        getSite (group) {
            this.siteName = group.display
            this.inputSite = group.value
        },
        formattedDisplay (result) {
          return result.name + ' [' + result.code + ']'
        },
        formattedDisplay2 (result) {
          return result.name + ' [' + result.template_code + ']'
        },
        terminalTemplatesEndpoint (input) {
            return this.endPoint + '/terminal_templates?name=' + input
        },
        getTerminalTemplate(group) {
            this.templateName = group.display
            this.inputTemplate = group.value
        },
        create: async function() {
            var brandPayload = {terminal: {name: this.inputName.trim(), code: this.inputCode.trim(), 
                                           reference_code: this.inputReferenceCode, remark: this.inputRemark, status: 'A', 
                                           site_id: this.inputSite, terminal_template_id: this.inputTemplate,
                                           serial_no: this.inputSerialNo, machine_no: this.inputMachineNo, permit_no: this.inputPermitNo}
                                 }
           var post_request = await HTTPRequest.postRequest(this.endPoint + 'terminals', null, brandPayload)    
           if(post_request == undefined){
                this.$emit('refreshPage', event)
           } else {
               if(post_request["error"] == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    alert(post_request["error"])
                    this.$router.push("/")
                }
           }
        },
        update: async function(){
            var brandPayload = {terminal: {name: this.inputName.trim(), code: this.inputCode.trim(), 
                                           reference_code: this.inputReferenceCode, remark: this.inputRemark, 
                                           site_id: this.inputSite, terminal_template_id: this.inputTemplate,
                                           serial_no: this.inputSerialNo, machine_no: this.inputMachineNo, permit_no: this.inputPermitNo}
                                 }
            var put_request = await HTTPRequest.putRequest(this.endPoint + 'terminals/' + this.profileId, null, brandPayload) 
            if(put_request == undefined){
                this.$emit('refreshPage', event)
           } else {
               if(put_request["error"] == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    alert(put_request["error"])
                    this.$router.push("/")
                }
           }
        }
    }
}
</script>

<style>
</style>